<mat-card
  class="__card  c-tip-card-card"
  [style.padding.px]="spacing()"
  [style.padding-right.px]="!!icon() && iconEndPosition() ? iconSpacing() : spacing()"
  [style.padding-left.px]="!!icon() && iconStartPosition() ? iconSpacing() : spacing()"
  [class.is-tip]="theme() === 'tip'"
  [class.is-warning]="theme() === 'warning'"
  [class.has-icon]="!!icon()"
  [class.icon-start]="iconStartPosition()"
  [class.icon-end]="iconEndPosition()">
  @if (icon()) {
    <mat-icon class="__icon  c-tip-card-icon" fontSet="material-icons-outlined">{{ icon() }}</mat-icon>
  }
  <ng-content />
</mat-card>
